const getUserAgent = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return '';
  }

  return navigator.userAgent;
};

export const isEdge = () => /Edg/i.test(getUserAgent());

export const isChrome = () => /Chrome/i.test(getUserAgent()) && !isEdge();

export const isSafari = () =>
  /Safari/i.test(getUserAgent()) && !isChrome() && !isEdge();

export const isFirefox = () => /Firefox/i.test(getUserAgent());

export const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    getUserAgent(),
  );

export const getBrowserName = () => {
  if (isEdge()) return 'Edge';
  if (isChrome()) return 'Chrome';
  if (isSafari()) return 'Safari';
  if (isFirefox()) return 'Firefox';

  return;
};
